import React, { useEffect, useRef, useState } from 'react';
import { MenuForm } from '../Menu.js';
import { SecurityElement } from '../elements/security_element.js';
import { useAPICall } from '../../hooks/useAPICall.js';
import { PRCInput } from '../controls/prcinput.js';
import { PRCDropDown } from '../controls/prcdropdown.js';
import { useNavigate } from 'react-router-dom';
import { PageMenuElement } from '../elements/page_menu.js';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import "../../css/main.css"


export function AdminNewMemberForm() {

    const [memberData] = useState([]);
    const [membershipTypeData, setMembershipTypeData] = useState([]);
    const [pageData, setPageData] = useState();
    const [competencyData, setCompetencyData] = useState([]);
    const [membershipStatus, setMembershipStatus] = useState([]);
    const [memberStatus, setMemberStatus] = useState(1);
    const [memberType, setMemberType] = useState(5);
    const [membershipNumber, setMembershipNumber] = useState('');
    const [familiesData, setFamilies] = useState([]);
    const [familyData, setFamily] = useState(0);
    const [dateStarted, setDateStarted] = useState(new Date());
    const [supplimentaryData, setSupplimentaryData] = useState([]);
    const navigate = useNavigate();

    let first_render = useRef(true);

    const { MakeCall } = useAPICall();


    const handleMemberDataFetchForCreate = (data) => {
        setPageData(data);
        setMembershipTypeData(data.components['membershiptypes']);
        setCompetencyData(data.components['competencytypes']);
        setMembershipStatus(data.components['membershipstatuses']);
        setMembershipNumber(data.components['membershipnumber']);
        setSupplimentaryData(data.components["supplimentarydata"]);
        let families = data.components['families'];
        families.push({ 'id': 0, 'description': 'NONE' });
        setFamilies(families);
        
    }

    if (first_render.current === true) {

        MakeCall('admin/creatememberpage', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\"}", handleMemberDataFetchForCreate, false);
        first_render.current = false;
    }
    useEffect(() => {



    });

    function handleNav(destination, state) {
        navigate(destination, state);
    }


    function handleMemberSaveComplete(data) {
        if (data.components['result'].succeeded === true) {

            let memberID = data.components['result'].data['idpeveril_member'];
            navigate("/ViewMember", { state: { memberID: memberID } });
        }

    }


    function handleSaveMember() {
        const data_entry = document.getElementsByTagName("input");

        let request = "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\", \"idpeveril_member\" : \"" + memberData.idpeveril_member + "\"";
        let comps = [];
        let supps = [];
        for (let i = 0; i < data_entry.length; i++) {
            if (data_entry[i].name.substring(0, 10) === 'MEMBER_IMP') {
                request += ", \"" + data_entry[i].id + "\" : \"" + data_entry[i].value + "\"";
            }
            else if (data_entry[i].name === 'MEMBER_DATA_SUPP') {
                const item = { "id": data_entry[i].id, "value": data_entry[i].value, "supp_type" : "STRING" };
                supps.push(item);
            }
            else if (data_entry[i].name === 'MEMBER_DATA_SUPP_CHK') {
                const item = { "id": data_entry[i].id, "value": data_entry[i].checked === true, "supp_type" : "BOOL" };
                supps.push(item);
            }
            else if (data_entry[i].name.substring(0, 10) === 'MEMBER_CHK') {
                const item = { "id": data_entry[i].id, "allowed": data_entry[i].checked === true };
                comps.push(item);
            }
        }
        request += ", \"date_started\" : \"" + dateStarted.toLocaleDateString() + "\"";
        const data_entry_drp = document.getElementsByTagName("select");
        for (let i = 0; i < data_entry_drp.length; i++) {
            if (data_entry_drp[i].name.substring(0,10) === 'MEMBER_IMP') {
                request += ", \"" + data_entry_drp[i].id + "\" : \"" + data_entry_drp[i].value + "\"";
            }
        }


        request += ", \"competencies\" : " + JSON.stringify(comps) ;
        request += ", \"supplimentary\" : " + JSON.stringify(supps) + "}";
        MakeCall('admin/createmember', request, handleMemberSaveComplete, true);

    }


    function ShowCompetencies() {
        let result = [];
        for (let i = 0; i < competencyData.length; i++) {
            const competency_item = competencyData[i];

            result.push(<div className='formrow' key={competency_item.id}>
                <div className='formlabel'>{competency_item.description}</div>
                <div className='formvalue'><input className='prccheckbox' type='checkbox' id={competency_item.id} name={'MEMBER_CHK_'+ competency_item.id} /></div>
            </div>);
        }
        return result;

    }
    function handleStatusChange(status) {
        setMemberStatus(status);
    }

    function handleTypeChange(type) {
        setMemberType(type);
    }
    function onPageMenuClick(onclickname) {
        switch (onclickname) {
            case 'goback':
                handleNav("/Admin");
                break;
            case 'savechanges':
                handleSaveMember();
                break;
            default:
                break;
        }
    }
    function handleFamilyChange(family) {
        setFamily(family);
      
    }


    function ShowSupplimentaryData()
    {
      let result = [];
      if(supplimentaryData != null)
      {
      if (supplimentaryData.length > 0) {
       
        for (let i = 0; i < supplimentaryData.length; i++) {
          if(supplimentaryData[i].supplimentary_data_type === "BOOL")
          {
              if(supplimentaryData[i].data_value === "Y")
              {
                  result.push(<div className='formrow' key={supplimentaryData[i].supplimentary_data_name} >
                  <div className='formlabel'>{supplimentaryData[i].supplimentary_data_name}</div>
                      <div className='formvalue'>
                      <input className='prccheckbox' type='checkbox' id={supplimentaryData[i].supplimentary_data_name + "_" + supplimentaryData[i].idsupplimentary_data_type} defaultChecked='true' name='MEMBER_DATA_SUPP_CHK' />
                      </div>
                  </div>);
              }
              else
              {
                  result.push(<div className='formrow' key={supplimentaryData[i].supplimentary_data_name} >
                  <div className='formlabel'>{supplimentaryData[i].supplimentary_data_name}</div>
                      <div className='formvalue'>
                      <input className='prccheckbox' type='checkbox' id={supplimentaryData[i].supplimentary_data_name + "_" + supplimentaryData[i].idsupplimentary_data_type} name='MEMBER_DATA_SUPP_CHK'  />
                      </div>
                  </div>);
              }
          }
          else
          {
              result.push(<div className='formrow' key={supplimentaryData[i].supplimentary_data_name} >
              <div className='formlabel'>{supplimentaryData[i].supplimentary_data_name}</div>
                  <div className='formvalue'>
                  <PRCInput id={supplimentaryData[i].supplimentary_data_name + "_" + supplimentaryData[i].idsupplimentary_data_type} value={supplimentaryData[i].data_value} className='logininput' name='MEMBER_DATA_SUPP' />
                  </div>
              </div>);
          }
    
        }
        
      }
      }
    
      return result;
    }

    return (

        <div>

            {SecurityElement(pageData)}
            {MenuForm()}

            <div className="contentdiv">
                {PageMenuElement("Create Member", [{ "name": "Back", "onclick": "goback" },
                { "name": "Save Changes", "onclick": "savechanges" }], onPageMenuClick)}
                <div id='AdminEditMember' >

                    <div className='formbox'>
                        <div className='formtitle'>Details</div>
                        <div className='formrow'>
                            <div className='formlabel'>Status</div>
                            <div className='formvalue'>
                                <PRCDropDown id='idpeveril_status' className='logininput' options={membershipStatus} value={memberStatus} name='MEMBER_IMP_STATUS' ownerID={memberData.idpeveril_member} onChange={handleStatusChange} />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Number</div>
                            <div className='formvalue'>
                                <PRCInput id='membership_number' value={membershipNumber} className='logininput' name='MEMBER_IMP_MEMNO' />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Type</div>
                            <div className='formvalue'>
                                <PRCDropDown id='idpeveril_membership_type' className='logininput' options={membershipTypeData} value={memberType} name='MEMBER_IMP_TYPE' ownerID={memberData.idpeveril_member} onChange={handleTypeChange} />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Forename</div>
                            <div className='formvalue'>
                                <PRCInput id='forename'  className='logininput' name='MEMBER_IMP_FORENAME' />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Surname</div>
                            <div className='formvalue'>
                                <PRCInput id='surname' className='logininput' name='MEMBER_IMP_SURNAME' inputtype='text' />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Family</div>
                            <div className='formvalue'>
                                <PRCDropDown id='idpeveril_family' className='logininput' options={familiesData} value={familyData} name='MEMBER_IMP_FAM' onChange={handleFamilyChange}  />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Start Date</div>
                            <div className='formvalue'>
                            {<DatePicker
                                showIcon
                                selected={dateStarted}
                                onChange={(date) => setDateStarted(date)}
                                name='MEMBER_IMP_DATE'
                                dateFormat="dd/MM/yyyy" />}
                            </div>
                        </div>
                        
                    </div>
                    <div className='formbox'>
                        <div className='formtitle'>
                            Contact Details
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Email</div>
                            <div className='formvalue'>
                                <PRCInput id='email'  className='logininput' name='MEMBER_IMP_EMAIL' inputtype='email' />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Password</div>
                            <div className='formvalue'>
                                <PRCInput id='password'  className='logininput' name='MEMBER_IMP_PASSWORD' />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Mobile</div>
                            <div className='formvalue'>
                                <PRCInput id='mobile_number'className='logininput' name='MEMBER_IMP_MOB' /></div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Home</div>
                            <div className='formvalue'>
                                <PRCInput id='fixed_line_number'  className='logininput' name='MEMBER_IMP_FIXED' />
                            </div>
                        </div>
                    </div>
                    <div className='formbox'>
                        <div className='formtitle'>
                        Supplimatary Info
                        </div>          
                    {ShowSupplimentaryData()}
                    </div>
                    <div className='formbox'>
                        <div className='formtitle'>
                            Address
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>House / Number</div>
                            <div className='formvalue'>
                                <PRCInput id='house'  className='logininput' name='MEMBER_IMP_HOUSE' />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Street</div>
                            <div className='formvalue'>
                                <PRCInput id='street'  className='logininput' name='MEMBER_IMP_STREET' />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Area</div>
                            <div className='formvalue'>
                                <PRCInput id='area' className='logininput' name='MEMBER_IMP_AREA' />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Town</div>
                            <div className='formvalue'>
                                <PRCInput id='town'  className='logininput' name='MEMBER_IMP_TOWN' />
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Country</div>
                            <div className='formvalue'>
                                <PRCInput id='country' className='logininput' name='MEMBER_IMP_COUNTRY' /></div>
                        </div>
                        <div className='formrow'>
                            <div className='formlabel'>Postcode</div>
                            <div className='formvalue'>
                                <PRCInput id='postcode' className='logininput' name='MEMBER_IMP_POSTCODE' /></div>
                        </div>
                    </div>
                    <div className='formbox'>
                        <div className='formtitle'>
                            Competencies
                        </div>
                        {ShowCompetencies()}
                    </div>

                </div>
            </div>
        </div>


    );
}


